import { format, parseISO } from 'date-fns'
import { renderToString } from 'react-dom/server'

const columns = [
  {
    data: 'name',
    className: 'bold',
    width: '50%',
    render: (data, type, row, meta) => {
      const inBuilt = row['system_template'] == 'true' ? ' (in-built template)' : ''
      const updatedDate = row['updated_at'] ? format(parseISO(row['updated_at'].replace(' ', 'T').replace(' UTC', 'Z')), "do MMMM yyyy, HH:mm") : ''
      return renderToString(
        <div>
          <a href={`/admin/settings/flow_templates/${row['id']}/edit`}>{data}{inBuilt}</a>
          <br />
          <span className="small-text">Last updated: {updatedDate}</span>
        </div>
      )
    }
  },
  {
    data: 'enabled_for_new_pages',
    orderable: false,
    width: '15%',
    render: (data, type, row, meta) =>
      data == 'true' ? 'Enabled' : 'Disabled',
  },
  {
    data: 'in_use',
    orderable: false,
    width: '15%',
    render: (data, type, row, meta) =>
      data == 'true' ? 'In Use' : 'Not In Use',
  },
  {
    data: 'id',
    orderable: false,
    className: 'right',
    width: '20%',
    render: (data, type, row) => {
      if (row['system_template'] === 'true') {
        return ''
      }
      return row.discarded === 'true'
        ? renderToString(
          <button
            data-flow-template-id={data}
            className="button small secondary restore-flow-template"
            type="button"
          >
            Restore
          </button>
        )
        : renderToString(
          <button
            data-flow-template-id={data}
            className="button small red archive-flow-template"
            type="button"
          >
            Archive
          </button>
        )
    }
  },
  { data: 'updated_at', visible: false },
]

const headers = ['Name', 'New Pages?', 'In Use?', '', 'Updated']

const filters = [
  {
    name: 'Show archived only', customParam: 'show_archived', kind: 'radio', options: [
      { value: 1, label: 'Yes' },
    ]
  },
]

const sorters = [
  { column: 0, label: 'Alphabetically (A-Z)', order: 'asc' },
  { column: 0, label: 'Alphabetically (Z-A)', order: 'desc' },
  { column: 4, label: 'Updated (newest)', order: 'desc' },
  { column: 4, label: 'Updated (oldest)', order: 'asc' },
]

const order = [[0, "asc"]]

export { columns, headers, filters, sorters, order }